document.addEventListener("DOMContentLoaded", function () {
  console.log("Quickbuy script loaded!"); // Bekræfter at scriptet kører

  // Opdater variant-id på knappen, når en variant vælges
  document.body.addEventListener("change", function (event) {
    let variantSelect = event.target.closest(".variant-select");
    if (variantSelect) {
      event.preventDefault(); // Stopper Shopify fra at navigere væk
      event.stopPropagation();

      let productId = variantSelect.getAttribute("data-product-id");
      let selectedVariantId = variantSelect.value;

      let addToCartBtn = document.querySelector(
        `.quick-add-to-cart-btn[data-product-id="${productId}"]`
      );
      if (addToCartBtn) {
        addToCartBtn.setAttribute("data-variant-id", selectedVariantId);
        console.log(
          `✅ Variant opdateret for produkt ${productId}: ${selectedVariantId}`
        );
      } else {
        console.error("❌ Kunne ikke finde knappen for produktet.");
      }
    }
  });

  // Håndter klik på "Tilføj" knappen og send den valgte variant til Shopify's cart API
  document.body.addEventListener("click", function (event) {
    let quickAddBtn = event.target.closest(".quick-add-to-cart-btn");

    if (quickAddBtn) {
      event.preventDefault();
      let variantId = quickAddBtn.getAttribute("data-variant-id");

      if (!variantId) {
        console.error(
          "❌ Variant ID mangler! Standard variant bruges i stedet."
        );
        return;
      }

      console.log(`🛒 Forsøger at tilføje variant ${variantId} til kurven...`);

      let formData = {
        id: variantId,
        quantity: 1,
      };

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("✅ Produkt tilføjet til kurven:", data);
          document.dispatchEvent(new CustomEvent("theme:open-cart-drawer"));
          document.dispatchEvent(new CustomEvent("theme:cartchanged"));
        })
        .catch((error) => {
          console.error("❌ Fejl ved tilføjelse til kurv:", error);
        });
    }
  });
});

  window.addEventListener('DOMContentLoaded', function () {
    function formatMoney(cents) {
      return (cents / 100).toLocaleString('da-DK', {
        style: 'currency',
        currency: 'DKK'
      });
    }

document.body.addEventListener("change", function (e) {
  const select = e.target.closest(".variant-select");
  if (!select) return;

  const variantId = select.value;
  const productId = select.dataset.productId;

  let product = window.ProductData?.[productId];
  if (!product) {
    const el = document.querySelector(`[data-product-id="${productId}"]`);
    if (el && el.dataset.productJson) {
      try {
        product = JSON.parse(el.dataset.productJson);
        window.ProductData = window.ProductData || {};
        window.ProductData[productId] = product;
      } catch (e) {
        console.error("❌ Kunne ikke parse JSON:", e);
        return;
      }
    }
  }

  const variant = product.variants.find(v => v.id == variantId);
  if (!variant) return;

  const formatMoney = (cents) =>
    (cents / 100).toLocaleString("da-DK", {
      style: "currency",
      currency: "DKK",
    });

  const priceEl = document.querySelector(
    `[data-price][data-product-id="${productId}"]`
  );
  if (priceEl) priceEl.textContent = formatMoney(variant.price);

  const comparePriceEl = document.querySelector(
    `[data-compare-at-price][data-product-id="${productId}"]`
  );
  if (comparePriceEl) {
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      comparePriceEl.style.display = "inline";
      comparePriceEl.textContent = formatMoney(variant.compare_at_price);
    } else {
      comparePriceEl.style.display = "none";
    }
  }

  // Opdater variant-id på tilføj-knappen (hvis den findes)
  const addToCartBtn = document.querySelector(
    `.quick-add-to-cart-btn[data-product-id="${productId}"]`
  );
  if (addToCartBtn) {
    addToCartBtn.setAttribute("data-variant-id", variantId);
  }
});

  });